<template>
  <v-dialog v-model="item.dialog" width="600">
    <template v-slot:activator="{ on: menu, attrs }">
      <v-tooltip bottom>
        <template v-if="item.handleMethod == 'handleArchive'" v-slot:activator="{ on: tooltip }">
          <v-btn @click="() => send()" dark v-bind="attrs" v-on="{ ...tooltip, ...menu }" color="primary" fab x-large>
            <v-icon>{{ item.icon }}</v-icon>
          </v-btn>
        </template>

        <template v-else-if="item.handleMethod == 'handleBDD Dumps'" v-slot:activator="{ on: tooltip }">
          <v-btn @click="() => sendSQL()" dark v-bind="attrs" v-on="{ ...tooltip, ...menu }" color="primary" fab x-large>
            <v-icon>{{ item.icon }}</v-icon>
          </v-btn>
        </template>

        <template v-else v-slot:activator="{ on: tooltip }">
          <v-btn dark v-bind="attrs" v-on="{ ...tooltip, ...menu }" color="primary" fab x-large>
            <v-icon>{{ item.icon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ item.handleMethod.split("handle")[1] }}</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-app-bar color="primary" dark>
        <template v-slot:img="{ props }">
          <v-img v-bind="props" gradient="to top right, rgba(19,84,122,.5), rgba(128,208,199,.8)"></v-img>
        </template>
        <v-app-bar-nav-icon>
          <v-icon>mdi-cloud</v-icon>
        </v-app-bar-nav-icon>
        <v-app-bar-title>{{
          item.handleMethod.split("handle")[1]
        }}</v-app-bar-title>
      </v-app-bar>
      <v-card-text class="mt-2">
        <strong v-if="item.handleMethod != 'handleArchive' && item.handleMethod != 'handleBDD Dumps'">
          Your are parametrizing some
          {{ item.handleMethod.split("handle")[1] }} for {{ selectedKiosks[0] }}
          <p v-if="selectedKiosks.length > 1">
            and {{ selectedKiosks.length - 1 }} other kiosks
          </p>
        </strong>
        <no-sleep-config @sendNoSleep="handle_function_call(item.handleMethod, $event)"
          v-if="item.handleMethod.split('handle')[1] == 'NoSleep'" />
        <get-report-config @sendGetReport="handle_function_call(item.handleMethod, $event)"
          v-if="item.handleMethod.split('handle')[1] == 'GetReport'" />
        <get-diag-config @sendGetDiag="handle_function_call(item.handleMethod, $event)"
          v-if="item.handleMethod.split('handle')[1] == 'GetDiag'" />
        <app-update-config @sendAppUpdate="handle_function_call(item.handleMethod, $event)"
          v-if="item.handleMethod.split('handle')[1] == 'AppUpdate'" />
        <debug-component :data="selectedKiosks[0]" v-if="
          item.handleMethod.split('handle')[1] == 'Debug' &&
          selectedKiosks.length == 1
        " />
        <get-set-param-config @sendGetSetParam="handle_function_call(item.handleMethod, $event)"
          v-if="item.handleMethod.split('handle')[1] == 'GetSetParam'"></get-set-param-config>
        <get-set-properties-config @sendGetSetProperties="handle_function_call(item.handleMethod, $event)"
          v-if="item.handleMethod.split('handle')[1] == 'GetSetProperties'"></get-set-properties-config>
        <we-repair-config @sendWeRepair="handle_function_call(item.handleMethod, $event)"
          v-if="item.handleMethod.split('handle')[1] == 'WeRepair'">
        </we-repair-config>
        <reset-name-config @sendResetName="handle_function_call(item.handleMethod, $event)"
          v-if="item.handleMethod.split('handle')[1] == 'ResetName'"></reset-name-config>
        <kill-java-config @sendKillJava="handle_function_call(item.handleMethod, $event)"
          v-if="item.handleMethod.split('handle')[1] == 'KillJava'"></kill-java-config>
        <get-archive :data="selectedKiosks" :files="files" v-if="item.handleMethod.split('handle')[1] == 'Archive' &&
          selectedKiosks.length == 1"></get-archive>
        <get-dump :data="selectedKiosks" :files="sqlFiles" v-if="item.handleMethod.split('handle')[1] == 'BDD Dumps' &&
          selectedKiosks.length == 1"></get-dump>
        <v-alert :color="type" :icon="alertIcon" outlined value v-if="type">
          Total calls : {{ successErrors.total }}
          <br />
          Passed : {{ successErrors.succ }}
          <br />
          Errors : {{ successErrors.err }}
        </v-alert>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import AppUpdateConfig from "../configComponents/AppUpdateConfig.vue";
import GetDiagConfig from "../configComponents/GetDiagConfig.vue";
import GetReportConfig from "../configComponents/GetReportConfig.vue";
import NoSleepConfig from "../configComponents/NoSleepConfig.vue";
import DebugComponent from "../tools/DebugComponent.vue";
import GetSetParamConfig from "../configComponents/GetSetParamConfig.vue";
import GetSetPropertiesConfig from "../configComponents/GetSetPropertiesConfig.vue";
import GetArchive from "../configComponents/ArchiveConfig.vue";
import GetDump from "../configComponents/DumpBDDConfig.vue";
import { sendDatasAtPathForKiosks, setLoadingState } from "@/services/RequestService";
import WeRepairConfig from "../configComponents/WeRepairConfig.vue";
import ResetNameConfig from "../configComponents/ResetNameConfig.vue";
import KillJavaConfig from "../configComponents/KillJavaConfig.vue";
import { getListFilesNameInDirectory, getListSQLFilesNameInDirectory } from '@/services/RequestService';
import { store } from "@/models/Store.js";
const jobTypes = {
  noSleep: 'NoSleepJob',
  getReport: 'GetReportJob',
  setOrGetConf: 'SetOrGetConfJob',
  setOrGetUser: 'SetOrGetUserJob',
  setUser: 'SetUserJob',
  getUser: 'GetUserJob',
  setConf: 'SetConfJob',
  getConf: 'GetConfJob',
  weRepair: 'WeRepairJob',
  getDiag: 'GetDiagJob',
  appUpdate: 'AppUpdateJob',
  custom: 'CustomJob',
  setOrGetParam: 'SetOrGetParamJob',
  setParam: 'SetParamJob',
  getParam: 'GetParamJob',
  killJava: 'KillJavaJob',
  resetName: 'ResetNameJob',
  setOrGetProperties: 'SetOrGetPropertiesJob',
  setProperties: 'SetPropertiesJob',
  getProperties: 'GetPropertiesJob',
  archive: 'archiveJob',
  dumpBDD: 'dumpBDD'
};
export default {
  components: {
    NoSleepConfig,
    GetReportConfig,
    GetDiagConfig,
    AppUpdateConfig,
    DebugComponent,
    GetSetParamConfig,
    WeRepairConfig,
    KillJavaConfig,
    ResetNameConfig,
    GetSetPropertiesConfig,
    GetArchive,
    GetDump
  },
  props: {
    item: Object,
    selectedKiosks: Array,
  },
  data: () => ({
    //for jobs post alert (success and errors)
    successErrors: null,
    type: null,
    elapse: null,
    alertIcon: null,
    files: [],
    sqlFiles : []
  }),
  methods: {
    getDateFromFileName(fileName) {
      // Extrait la date du nom de fichier (Assumant le format: wegaz2.log_20220728.log.gz)
      const dateStr = fileName.match(/\d{8}/)[0]; // Extrait la cha�ne de caract�res de 8 chiffres correspondant � la date
      const year = dateStr.substr(0, 4);
      const month = dateStr.substr(4, 2) - 1; // Les mois dans l'objet Date commencent � partir de 0 (janvier = 0)
      const day = dateStr.substr(6, 2);
      return new Date(year, month, day);
    },
    async send() {
      try {
        this.files = [];
        let listfiles = await getListFilesNameInDirectory(this.$props.selectedKiosks);
        if (listfiles.length > 0) {
          listfiles.sort((a, b) => {
            const dateA = this.getDateFromFileName(a.name);
            const dateB = this.getDateFromFileName(b.name);
            return dateB.getTime() - dateA.getTime();
          });
          listfiles.forEach(item => {
            this.files.push(item);
          });
        }
        return listfiles;
      } catch (error) {
        console.error('Erreur lors de la r�cup�ration des fichiers:', error);
        return []; // Retourne une liste vide en cas d'erreur
      }
    },
    async sendSQL() {
        try {
          this.sqlFiles = [];
          let listfiles = await getListSQLFilesNameInDirectory(this.$props.selectedKiosks, true);
          if (listfiles.length > 0) {
            listfiles.forEach(item => {
              this.sqlFiles.push(item);
            });
          }
          return listfiles;
        } catch (error) {
          console.error('Erreur lors de la r�cup�ration des fichiers:', error);
          return []; // Retourne une liste vide en cas d'erreur
        }
    },
    //show v-alert for some time depending on type
    showAlert: function (type) {
      this.type = type;
      let timer = this.showAlert.timer;
      if (timer) {
        clearTimeout(timer);
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null;
      }, 3000 * 5);
      this.elapse = 1;
      let t = this.showAlert.t;
      if (t) {
        clearInterval(t);
      }
      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0;
          clearInterval(this.showAlert.t);
        } else {
          this.elapse++;
        }
      }, 1000);
    },
    //choose the colors and icon toshow in v-alert considering success and errors of API calls
    showAlertConsideringSuccessAndErrors: function () {
      //console.log(this.successErrors);
      if (this.successErrors.err === 0) {
        this.showAlert("success");
        this.alertIcon = "mdi-hand-okay";
      } else if (this.successErrors.succ === 0) {
        this.showAlert("error");
        this.alertIcon = " mdi-close-circle-outline";
      } else {
        this.showAlert("warning");
        this.alertIcon = "mdi-alert-decagram-outline";
      }
    },
    handleArchive: function () {
      if (this.$router.history.current.name != "archive")
        this.$router.push("/archive");
      else
        this.$router.push("/");
    },
    handle_function_call: async function (function_name, event) {
      let SuccErrReturned = await this[function_name](event); 
      if (this.selectedKiosks.length < 2) {
        await store.updateCheckHistoryList();
      }
      setLoadingState(false);
      this.successErrors = SuccErrReturned;
      this.showAlertConsideringSuccessAndErrors();
    },
    handleAppUpdate: async function (evt) {
      let isCritic = true;
      if (evt === null) {
        isCritic = false;
      }
      return await sendDatasAtPathForKiosks(
        { isCritic: isCritic },
        "/job/" + jobTypes.appUpdate + "/",
        this.selectedKiosks
      );
    },
    handleNoSleep: async function (evt) {
      //console.log(evt);
      //console.log("handleNoSleep");
      return await sendDatasAtPathForKiosks(
        { date: evt },
        "/job/" + jobTypes.noSleep + "/",
        this.selectedKiosks
      );
    },
    handleGetReport: async function (evt) {
      //console.log("handleGetReport");
      //console.log(evt);
      return await sendDatasAtPathForKiosks(
        { reportToGet: evt },
        "/job/" + jobTypes.getReport + "/",
        this.selectedKiosks
      );
    },
    handleGetDiag: async function (evt) {
      //console.log("DIAG TO MAKE ");
      //console.log(evt);
      return await sendDatasAtPathForKiosks(
        { periphsToDiag: evt },
        "/job/" + jobTypes.getDiag + "/",
        this.selectedKiosks
      );
    },
    handleGetSetParam: async function (evt) {
      //console.log(evt);
      return await sendDatasAtPathForKiosks(
        evt,
        "/job/" + jobTypes.setOrGetParam + "/",
        this.selectedKiosks
      );
    },
    handleGetSetProperties: async function (evt) {
      //console.log("PROPERTIIIES")
      //console.log(evt);
      return await sendDatasAtPathForKiosks(
        evt,
        "/job/" + jobTypes.setOrGetProperties + "/",
        this.selectedKiosks
      );
    },
    handleWeRepair: async function (evt) {
      //console.log(evt);
      return await sendDatasAtPathForKiosks(
        evt,
        "/job/" + jobTypes.weRepair + "/",
        this.selectedKiosks
      );
    },
    handleResetName: async function (evt) {
      //console.log(evt);
      return await sendDatasAtPathForKiosks(
        evt,
        "/job/" + jobTypes.resetName + "/",
        this.selectedKiosks
      );
    },
    handleKillJava: async function (evt) {
      //console.log(evt);
      return await sendDatasAtPathForKiosks(
        evt,
        "/job/" + jobTypes.killJava + "/",
        this.selectedKiosks
      );
    },
  },
};
</script>